// Multi-engraving validation fix
// This script replaces the theme's faulty multi-engraving validation

document.addEventListener('DOMContentLoaded', function() {
  // Run BEFORE the theme's validation to disable it for multi-engraving
  document.addEventListener('click', function(event) {
    const addToCartButton = event.target.closest('[data-add-to-cart]');
    if (!addToCartButton) return;
    
    const form = addToCartButton.closest('form[data-product-form]');
    if (!form) return;
    
    const isMultiEngraving = form?.dataset.multiEngraving === "true" || form?.dataset.multiEngraving === "1";
    if (!isMultiEngraving) return;
    
    // Temporarily remove the multi-engraving attribute to disable theme's validation
    const originalValue = form.dataset.multiEngraving;
    form.removeAttribute('data-multi-engraving');
    
    let isValid = true;
    let hasVisibleSets = false;
    
    // Check each engraving set
    for (let i = 1; i <= 5; i++) {
      const setContainer = form.querySelector(`.engraving-set[data-index="${i}"]`);
      
      if (setContainer && window.getComputedStyle(setContainer).display !== 'none') {
        hasVisibleSets = true;
        
        const textareaContainer = setContainer.querySelector('.engraving-textarea');
        const fileContainer = setContainer.querySelector('.engraving-file');
        const textInput = setContainer.querySelector('textarea');
        const fileInput = setContainer.querySelector('input[type="file"]');
        const positionInput = form.querySelector(`[name="properties[Position ${i}]"]`);
        
        // Check if textarea container is visible and validate text input
        if (textareaContainer && window.getComputedStyle(textareaContainer).display !== 'none') {
          if (!textInput || !textInput.value.trim()) {
            isValid = false;
            textareaContainer.classList.add('error');
          } else {
            textareaContainer.classList.remove('error');
          }
        } else if (textareaContainer) {
          textareaContainer.classList.remove('error');
        }
        
        // Check if file container is visible and validate file input
        if (fileContainer && window.getComputedStyle(fileContainer).display !== 'none') {
          if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
            isValid = false;
            fileContainer.classList.add('error');
          } else {
            fileContainer.classList.remove('error');
          }
        } else if (fileContainer) {
          fileContainer.classList.remove('error');
        }
        
        // Check position selection
        if (!positionInput || !positionInput.value.trim()) {
          isValid = false;
          const swatchGroup = setContainer.querySelector('.engraving-swatches');
          let swatchError = setContainer.querySelector('.swatch-error-message');
          if (!swatchError && swatchGroup) {
            swatchError = document.createElement('div');
            swatchError.className = 'error-message swatch-error-message';
            swatchError.innerHTML = '<span class="alert-text">Please select a position.</span>';
            swatchGroup.parentNode.insertBefore(swatchError, swatchGroup.nextSibling);
          }
        } else {
          const swatchError = setContainer.querySelector('.swatch-error-message');
          if (swatchError) swatchError.remove();
        }
      }
    }
    
    // If validation failed, prevent submission and restore the attribute
    if (!isValid && hasVisibleSets) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Restore the multi-engraving attribute
      form.setAttribute('data-multi-engraving', originalValue);
      
      // Show general error message
      const errorContainer = form.querySelector('[data-cart-errors-container]');
      if (errorContainer) {
        errorContainer.innerHTML = `
          <div class="errors" data-error>
            Please fill in all required fields and select positions for your engravings.
          </div>
        `;
        errorContainer.classList.add('is-visible');
      }
      
      return false;
    } else if (isValid && hasVisibleSets) {
      // Hide any error messages
      const errorContainer = form.querySelector('[data-cart-errors-container]');
      if (errorContainer) {
        errorContainer.classList.remove('is-visible');
      }
      
      // Restore the attribute after a short delay so theme can process normally
      setTimeout(() => {
        form.setAttribute('data-multi-engraving', originalValue);
      }, 100);
      
      // Let the event continue to the theme's handler
    }
  }, true); // Use capture phase to run before theme validation
}); 